import api from "./api";

const salesmanService = {
  list: (params = {}) => api.get("/salesmen", { params }),
  options: (params = {}) => api.get("/salesmen/options", { params }),
  get: (id) => api.get(`/salesmen/${id}`),
  create: (payload) => api.post("/salesmen", payload),
  update: (id, payload) => api.patch(`/salesmen/${id}`, payload),
  setStatus: (id, isActive) => api.patch(`/salesmen/${id}/status`, { isActive }),
  remove: (id) => api.delete(`/salesmen/${id}`),
  downloadExcel: (params = {}) =>
    api.get("/salesmen/export", { params, responseType: "blob" }),
  downloadSample: () =>
    api.get("/salesmen/import/sample", { responseType: "blob" }),
  previewImport: (file, onUploadProgress) => {
    const body = new FormData();
    body.append("file", file);
    return api.post("/salesmen/import/preview", body, { onUploadProgress });
  },
  commitImport: (file, onUploadProgress) => {
    const body = new FormData();
    body.append("file", file);
    return api.post("/salesmen/import", body, { onUploadProgress });
  },
};

export default salesmanService;
